import { makeStyle } from "../../../utils";

const styles = {};

styles['image'] = makeStyle({
    position: 'absolute', top: 0,
    objectFit: 'cover',
    height: '100%', width: '100%',
    backgroundColor: '#ff2e28',
    filter: 'blur(1.5px) brightness(1.15)',
});

export default styles;